<template>
  <b-modal
    :id="getId"
    :title="titleText"
    header-class="create-wizard-header"
    title-class="create-label"
    footer-class="create-wizard-footer"
    no-close-on-esc
    @hidden="closeForm"
  >
    <div class="wizard-container">
      <div class="content-wrapper">
        <div class="wizard-form">
          <div class="ncm-row">
            <label
              class="ncm-column-left field-label-high"
              :class="{ 'field-label-low': uploadedFile }"
            >
              {{ fileText }}
            </label>
            <div class="ncm-column-right">
              <file-upload @on-file-change="onFileUpload"></file-upload>
            </div>
            <div class="loader-wrapper" v-if="this.processingNewVersion">
              <div class="loader"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template v-slot:modal-footer>
      <button class="modal-btn modal-cancel-btn" @click="closeForm">
        {{ getMessageText(messages.CANCEL) }}
      </button>
      <button
        class="modal-btn modal-save-btn"
        @click="doUpdate"
        :disabled="shouldBeDisabled"
      >
        {{ getMessageText(messages.OK) }}
      </button>
    </template>
  </b-modal>
</template>

<script>
  import { mapState } from "vuex";
  import FileUpload from "@/components/FileUpload.vue";
  import services from "@/services";
  import { TOAST_CONFIG } from "@/static/global-variables";

  export default {
    name: "NewCustomContentVersionModal",
    components: { FileUpload },
    props: {
      app: Object
    },
    data() {
      return {
        uploadedFile: null,
        processingNewVersion: false,
        fileIsValid: false
      };
    },
    computed: {
      ...mapState({
        messages: "messages"
      }),
      getId() {
        return "new-ccv-" + this.app.uuid;
      },
      titleText() {
        return this.$t("newCustomPageVersion");
      },
      fileText() {
        return this.$t("file");
      },
      shouldBeDisabled() {
        return this.uploadedFile === null || !this.fileIsValid;
      }
    },
    methods: {
      closeForm() {
        this.clearForm();
        this.$bvModal.hide(this.getId);
      },
      clearForm() {
        this.uploadedFile = null;
        this.processingNewVersion = false;
        this.fileIsValid = false;
      },
      onFileUpload(val) {
        this.fileIsValid = false;
        if (val !== null) {
          services
            .validateCustomContentFromFile(val.file)
            .then(resp => {
              if (resp.data && resp.data.status === "SUCCESS") {
                this.fileIsValid = true;
              } else {
                this.fileIsValid = false;
                this.displayErrorMessage(
                  this.messages.ERROR_WHILE_LOADING.Text_vod__c
                );
              }
            })
            .catch(err => {
              if (err.response && err.response.status === 400) {
                this.fileIsValid = false;
                this.displayErrorMessage(this.$t("indexHtmlMissing"));
              } else {
                this.fileIsValid = false;
                this.displayErrorMessage(
                  this.messages.ERROR_WHILE_LOADING.Text_vod__c
                );
              }
            });
          this.uploadedFile = val.file;
        }
      },
      displayErrorMessage(message) {
        this.$bvToast.toast(message, TOAST_CONFIG.BOTTOM_CENTER_ERROR);
      },
      async doUpdate() {
        let params = {
          file: this.uploadedFile,
          uuid: this.app.uuid,
          type: this.app.type
        };
        this.processingNewVersion = true;
        await services.updateCustomContentFile(params);
        this.navigateToEditPage(this.app);
        this.closeForm();
      },
      navigateToEditPage(app) {
        this.$router.push({
          name: "Deploy",
          params: {
            appId: app.uuid
          }
        });
      }
    }
  };
</script>

<style scoped>
  .modal-btn {
    position: relative;
    display: inline-flex;
    align-items: center;
    padding: 0;
    background: transparent;
    background-clip: border-box;
    border: 1px solid transparent;
    border-radius: 0.25rem;
    line-height: 1.875rem;
    color: #0070d2;
    -webkit-appearance: none;
    white-space: normal;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    text-decoration: none;
  }

  .modal-save-btn {
    margin-left: 0.5rem;
    padding-left: 1rem;
    padding-right: 1rem;
    text-align: center;
    vertical-align: middle;
    justify-content: center;
    transition: border 0.15s linear;
    background-color: #0070d2;
    border: 1px solid #0070d2;
    color: #fff;
  }

  .modal-cancel-btn {
    padding-left: 1rem;
    padding-right: 1rem;
    text-align: center;
    vertical-align: middle;
    justify-content: center;
    transition: border 0.15s linear;
    border: 1px solid #dddbda;
    background-color: #fff;
  }

  .modal-btn[disabled] {
    background-color: var(--DISABLED_BTN_GREY);
    border-color: var(--DISABLED_BTN_GREY);
    color: var(--WHITE);
  }
</style>
